import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCoins,
  faSparkles,
} from "@fortawesome/pro-solid-svg-icons";

import "./SeedanceBanner.scss";

export default function SeedanceBanner() {
  return (
    <div className="seedance-banner-container mb-4">
      <div className="seedance-blob" />

      <div className="seedance-inner">
        {/* 16:9 Video Box on the left (or top on mobile) */}
        {/* <div className="seedance-video-wrapper">
          <iframe
            className="seedance-video"
            src="https://player.vimeo.com/video/1170882965?autoplay=1&loop=1&muted=1&title=0&byline=0&portrait=0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Seedance 2.0 Preview"
            style={{ border: 0 }}
          />
        </div> */}

        <div className="seedance-content">
          <div className="seedance-label">
            <span className="seedance-label-badge">NEW</span>
            <FontAwesomeIcon icon={faSparkles} />
            <span>ArtCraft · by the FakeYou Team</span>
          </div>

          <div className="seedance-promo-row">
            <span className="seedance-promo-badge">
              🏷️ 30% off with code <strong>FAKEYOU</strong>
            </span>
          </div>

          <h2 className="seedance-title">
            Make movies with{" "}
            <span className="seedance-title-highlight">Seedance 2.0</span> -{" "}
            <span className="seedance-title-cheapest">
              cheaper than anywhere else.
            </span>
          </h2>

          <p className="seedance-desc">
            Seedance 2.0 model is live on ArtCraft before anywhere else. Create
            cinematic AI video with fluid motion and Hollywood-level scenes.
          </p>

          <div className="seedance-btns">
            <a
              href="https://getartcraft.com/?utm_source=fakeyou.com&utm_campaign=seedance2"
              className="seedance-btn"
            >
              Try ArtCraft Now
              <FontAwesomeIcon icon={faArrowRight} />
            </a>
            <a
              href="https://getartcraft.com/pricing?utm_source=fakeyou.com&utm_campaign=seedance2&ref=sd2fakeyou"
              className="seedance-btn seedance-btn--secondary"
            >
              <FontAwesomeIcon icon={faCoins} />
              Buy Seedance Credits
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
